<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
  <span *ngIf="$.row[$.adata.keyName] && $.row[$.adata.keyName]!='01/01/0001 00:00:00';else dash">
    {{getDate($.row[$.adata.keyName]) | date :$.adata.format }}
  </span>
  <ng-template #dash>-</ng-template>

</ng-container>